import { render, staticRenderFns } from "./LocalDeliveryRates.vue?vue&type=template&id=69940648&lang=pug&"
import script from "./LocalDeliveryRates.vue?vue&type=script&lang=js&"
export * from "./LocalDeliveryRates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
